// DENSO Promoter Training Manual content, restructured into 7 sequential
// modules to match the real DENSO training videos supplied by the client.
// Content sourced/adapted from the DENSO Promoter Training Manual.

export const DENSO_PRODUCT_VIDEO_URL =
  "https://customer-assets.emergentagent.com/job_denso-cert-academy/artifacts/hv2tnjlo_Denso%20Product%20Video.mp4";
export const SPARK_PLUGS_VIDEO_URL =
  "https://customer-assets.emergentagent.com/job_denso-cert-academy/artifacts/obxgpdgt_Spark%20Plugs.mp4";
export const OIL_FILTERS_VIDEO_URL =
  "https://customer-assets.emergentagent.com/job_denso-cert-academy/artifacts/nacn5n4m_Oil%20FIlers.mp4";
export const WIPER_BLADES_VIDEO_URL =
  "https://customer-assets.emergentagent.com/job_denso-cert-academy/artifacts/5ab2n4ge_Wiper%20blades.mp4";
export const SERVICE_KITS_VIDEO_URL =
  "https://customer-assets.emergentagent.com/job_denso-cert-academy/artifacts/b02s65yd_Service%20Kits.mp4";
export const TWIN_HORNS_VIDEO_URL =
  "https://customer-assets.emergentagent.com/job_denso-cert-academy/artifacts/hniuifa2_Twin%20Horns.mp4";
export const ROTATING_ELECTRICS_VIDEO_URL =
  "https://customer-assets.emergentagent.com/job_denso-cert-academy/artifacts/fgffx392_Danso%20Electronic%20Rotating%20Module.mp4";

export const TRAINING_MODULES = [
  {
    id: "module-1",
    order: 1,
    title: "Introduction Video",
    subtitle: "Who DENSO is, and why the brand is trusted",
    videoUrl: DENSO_PRODUCT_VIDEO_URL,
    keyPoints: [
      "DENSO is one of the world's leading automotive technology and components manufacturers (2nd largest in the world).",
      "DENSO is a Japanese company founded in 1949 — recognised globally for innovation, precision engineering, reliability and advanced automotive technology.",
      "DENSO is a global OEM (Original Equipment Manufacturer) — it supplies components directly to major vehicle manufacturers for factory-fitted vehicles.",
      "DENSO supplies leading manufacturers including Toyota, Isuzu, Honda, Mazda, Nissan, Suzuki, Ford, BMW, Mercedes-Benz, Hyundai, Kia and Volkswagen.",
      "Mechanics prefer DENSO because parts fit correctly, are reliable, create fewer customer comebacks, and deliver long-term satisfaction.",
      "PROMOTER TIP: Always focus on VALUE, PERFORMANCE and RELIABILITY when speaking to customers.",
    ],
  },
  {
    id: "module-2",
    order: 2,
    title: "Spark Plugs",
    subtitle: "Ignition technology and engine performance",
    videoUrl: SPARK_PLUGS_VIDEO_URL,
    keyPoints: [
      "A spark plug ignites the air/fuel mixture inside a petrol engine — without it, the engine cannot start or combust fuel correctly.",
      "DENSO offers advanced spark plug technologies: Iridium, Twin Tip Technology (TT), and Platinum — improving fuel economy, performance and durability.",
      "Iridium spark plugs use an extremely durable, heat-resistant metal — giving longer life, better combustion, improved fuel economy and reduced maintenance.",
      "Genuine DENSO spark plugs are laser-welded with precision electrode tips (0.4mm-0.55mm) — always buy from an authorised DENSO distributor to avoid counterfeits.",
      "SELLING POINT: \"DENSO spark plugs improve fuel efficiency and provide longer-lasting performance compared to standard plugs.\"",
    ],
  },
  {
    id: "module-3",
    order: 3,
    title: "Oil Filters",
    subtitle: "Protecting the engine, extending its life",
    videoUrl: OIL_FILTERS_VIDEO_URL,
    keyPoints: [
      "The oil filter protects the vehicle's engine oil system by removing dirt and contaminants from the engine oil.",
      "A clogged or poor-quality oil filter can lead to increased engine wear, reduced performance and costly repairs down the line.",
      "DENSO's Cool Gear range of filters (Oil, Air, Cabin and Fuel) meet OE-quality standards for filtration and durability.",
      "Clean oil filters help vehicles run more efficiently, extend engine life and reduce long-term repair costs.",
      "PROMOTER TIP: Recommend an oil filter change at every oil service to protect the engine and maintain performance.",
    ],
  },
  {
    id: "module-4",
    order: 4,
    title: "Wiper Blades",
    subtitle: "Visibility and safety in every condition",
    videoUrl: WIPER_BLADES_VIDEO_URL,
    keyPoints: [
      "Wiper blades are critical for driver visibility and safety, especially in rain, mud or snow.",
      "Poor-quality wipers streak, reduce visibility and can damage windscreens over time.",
      "Experts recommend replacing wiper blades every 6 to 12 months depending on weather conditions and blade quality.",
      "DENSO First Time Fit wiper blades (Conventional, Designer and Beam styles) offer OE fit and function, durability and quiet, streak-free performance.",
      "PROMOTER TIP: A low-profile insert and precise wiping edge means DENSO blades resist streaking better than competitor products.",
    ],
  },
  {
    id: "module-5",
    order: 5,
    title: "Service Kits",
    subtitle: "Everything needed for a complete service, in one box",
    videoUrl: SERVICE_KITS_VIDEO_URL,
    keyPoints: [
      "DENSO Service Kits include an Oil filter, Air filter, Cabin air filter, Fuel filter and Spark plugs — a full OE-quality servicing solution in one box.",
      "Filter Kits (without spark plugs) offer a more affordable option for cost-conscious customers, while still maintaining high-quality filtration performance.",
      "This dual offering gives workshops and retailers flexibility to offer a full premium service kit or a cost-saving filter kit option.",
      "PROMOTER TIP: Always highlight OE-quality standards and the convenience of having every component in one box.",
    ],
  },
  {
    id: "module-6",
    order: 6,
    title: "Twin Horns",
    subtitle: "Powerful, clear and reliable dual-tone sound",
    videoUrl: TWIN_HORNS_VIDEO_URL,
    keyPoints: [
      "DENSO Twin Horns combine a high-tone and low-tone horn for a powerful, distinctive dual-tone sound — louder and clearer than a standard single horn.",
      "Twin Horns include a built-in relay for simplified, faster installation.",
      "OE quality and reliability are built into every unit.",
      "PROMOTER TIP: DENSO Twin Horns come equipped with a built-in relay, making installation faster and easier while ensuring reliable operation.",
    ],
  },
  {
    id: "module-7",
    order: 7,
    title: "Rotating Electrics",
    subtitle: "Starters & Alternators — first time fit, every time",
    videoUrl: ROTATING_ELECTRICS_VIDEO_URL,
    keyPoints: [
      "Rotating Electrics cover Starter Motors (crank the engine to start it) and Alternators (generate power and charge the battery while the engine runs).",
      "A 'remanufactured' unit is a used OE component fully disassembled, inspected, rebuilt and tested to restore original performance — OE quality, cost effective, reliable, first-time fit.",
      "DENSO is the global leader in starter and alternator OEM share, backed by the First Time Fit promise and the lowest industry return rate.",
      "DENSO's patented Segment Conductor technology delivers up to 50% more power output and 20% less weight versus conventional alternators.",
      "FINAL PROMOTER CHECKLIST: know the product range and key selling points, wear correct DENSO branding, be professional and confident, listen carefully to customers, and always represent DENSO positively. Always ask yourself: \"How does this product help the customer?\"",
    ],
  },
];

export const TOTAL_MODULES = TRAINING_MODULES.length;
